@let value = quantity() ?? 0;
@let isBlank = quantity() === null;

<button
  decrement
  mat-stroked-button
  tabindex="-1"
  (click)="decrement()"
  [disabled]="decrementDisabled()"
  [class.remove]="iconType() === 'remove'"
  [class.delete]="iconType() === 'delete'"
  [class.clear]="iconType() === 'clear'"
>
  <mat-icon>{{ iconType() }}</mat-icon>
</button>

<ideal-number-input #quantityInput [formControl]="control()" [label]="label()" [placeholder]="placeholder()">
  <ng-content select="mat-hint:not([align='end'])" ngProjectAs="mat-hint:not([align='end'])"></ng-content>
  <ng-content select="mat-hint[align='end']" ngProjectAs="mat-hint[align='end']"></ng-content>
  <ng-content select="mat-error" ngProjectAs="mat-error"></ng-content>
  <ng-content select="[matError]" ngProjectAs="[matError]"></ng-content>
</ideal-number-input>

<!-- Nothing in the cart: a stroked button like "−", in blue. Above 0: the solid blue button. -->
@if (value > 0) {
  <button increment mat-flat-button tabindex="-1" (click)="increment()" [disabled]="value >= maxQuantity">
    <mat-icon>add</mat-icon>
  </button>
} @else {
  <button increment mat-stroked-button class="empty" tabindex="-1" (click)="increment()" [disabled]="value >= maxQuantity">
    <mat-icon>add</mat-icon>
  </button>
}
